export default {
  "enclosureWidth": 0,
  "enclosureHeight": 0,
  "enclosureThickness": 3.3,
  "boltThread": 5,
  "boltLengthExcess": 1,
  "boltLengthMinimum": 7.5,

  "adapterFillHole": 5,
  "adapterGlueHole": 3,
  "adapterHolesDistance": 3,

  "adapterThickness1": 3,
  "adapterThickness2": 5,
  "adapterHeadCornerPositionWidth": 0,
  "adapterHeadWidth": 10,
  "adapterHeadSlotWidth": 17,
  "adapterProfileShift": 2,
  "adapterSquareGlue": 0,
  "nutEdgeLength": 8,
  "nutThickness": 1.5
}
  